import { AdSystem } from '@lib/iab/iab-vast-model';

interface IAdSystem {
    version: string;
    _value: string;
}

const createAdSystem = ($adSystem: IAdSystem): AdSystem => {
    const adSystem = new AdSystem();
    adSystem.version = $adSystem.version;
    adSystem.name = $adSystem._value;
    return adSystem;
};

export default createAdSystem;
